export const stationFilterValues = ["currentStation", "otherStations"] as const;
export type StationFilter = (typeof stationFilterValues)[number];
